module.exports = __webpack_public_path__ + "static/media/att_31.50bed53d.jpg";